module.exports = __webpack_public_path__ + "img/icon-circle.1fa90bd9.svg";